export default {
  phone: /^[0-9().\-/]+$/,
  phoneChars: /[.\-()]/g,
  latitude: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
  longitude: /^[-+]?((1[0-7]\d|\d?\d)(\.\d+)?|180(\.0+)?)$/,
};